import { render, staticRenderFns } from "./SignatureUser.vue?vue&type=template&id=4668938b&scoped=true"
import script from "./SignatureUser.vue?vue&type=script&lang=js"
export * from "./SignatureUser.vue?vue&type=script&lang=js"
import style0 from "./SignatureUser.vue?vue&type=style&index=0&id=4668938b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668938b",
  null
  
)

export default component.exports